import { fetchJSON } from "@/api/utils.js";

export async function fetchHistory(target_id) {
  const url = "/api/history/thread";
  const resp = await fetchJSON(
    url,
    {
      target_id,
    },
    null,
    "get",
    false
  );
  return resp.data;
}
